import { render } from "./EscalationConfiguration.vue?vue&type=template&id=07c9916c"
import script from "./EscalationConfiguration.vue?vue&type=script&lang=js"
export * from "./EscalationConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "/private/var/www/html/digicheck-laravel-vue-app/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__